import { useEffect } from "react";

import { useTypedSelector } from "../store/store";

const GTM_SCRIPT_URL = "https://www.googletagmanager.com/gtm.js";
const GTM_NOSCRIPT_URL = "https://www.googletagmanager.com/ns.html";

export function useGTM() {
  const { gtm_container_id } = useTypedSelector((state) => state.environment);

  useEffect(() => {
    if (!gtm_container_id) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = `${GTM_SCRIPT_URL}?id=${gtm_container_id}`;
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `${GTM_NOSCRIPT_URL}?id=${gtm_container_id}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, [gtm_container_id]);
}
